// TouchDevice
function isTouchDevice() {
  var result = false;
  if (window.ontouchstart === null) {
    result = true;
  }  
  return result;
}
// VW
const setVw = function() {
  const vw = document.documentElement.clientWidth / 100;
  const vh = window.innerHeight / 100;
  const slh = Math.round((((document.documentElement.clientWidth / 375) - 1) / Math.pow(2,document.documentElement.clientWidth / 375) * 0.65 + 1) * 100000) / 100000;
  if(document.documentElement.clientWidth < 1770) {
    const plh = Math.round((((document.documentElement.clientWidth / 1366) - 1) / Math.pow(2,document.documentElement.clientWidth / 1366) * 1.3 + 1) * 100000) / 100000;
    document.getElementById('hwm-wrapper').style.setProperty('--plh', `${plh}`);
  } else {
    const plh = Math.round((((1770 / 1366) - 1) / Math.pow(2,1770 / 1366) * 1.3 + 1) * 100000) / 100000;
    document.getElementById('hwm-wrapper').style.setProperty('--plh', `${plh}`);
  }
  document.getElementById('hwm-wrapper').style.setProperty('--vw', `${vw}px`);
  document.getElementById('hwm-wrapper').style.setProperty('--vh', `${vh}px`);
  document.getElementById('hwm-wrapper').style.setProperty('--slh', `${slh}`);
}
// Toggle Height
function toggleHeight() {
  $('.toggle-content').each(function(){
    var contentHeight = Math.ceil($(this).find('.toggle-inner').height());
    $(this).attr('data-open-height',contentHeight);
  });
}
//Load
function initSwiper() {
  var swiper = new Swiper('.swiper', {
    loop: true,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    }
  });
}
$(window).on('load',function(){
	$('#hwm-wrapper').addClass('is-loaded');
  //Swiper
  if($(window).height() <= $(window).width()) {
    $.when(
      $('.swiper-slide[data-order="1"]').insertBefore($('.swiper-slide[data-order="2"]')),
      $('.swiper-slide[data-order="3"]').insertAfter($('.swiper-slide[data-order="2"]'))
    ).done(function(){
      initSwiper()
    });
  } else {
    initSwiper();
  }
});
//Func
$(function(){
  //Vw & TH
  setVw();
  toggleHeight();
  //Toggle Text
  $('.toggle-btn').on('click','a',function(){
    var container = $(this).closest('.toggle-container');
    var content = container.find('.toggle-content');
    container.toggleClass('is-open');
    if(container.hasClass('is-open')) {
      var contentHeight = content.attr('data-open-height');
      content.css('maxHeight',contentHeight+'px');
    } else {
      content.css('maxHeight','');
      if($(window).width() < $(window).height()) {
        var position = container.closest('.textarea').offset().top;
        $('body,html').animate({scrollTop:position}, 600);
      }
    }
    return false;
  });
  //Toggle Tab
  $('.tab-btns').on('click','a',function(){
    var index = $(this).closest('li').prevAll('li').length;
    var container = $(this).closest('.tab-container');
    container.find('.tab-btns').find('li').removeClass('is-current').eq(index).addClass('is-current');
    container.find('.series-detail_imagearea').find('.series-detail_image').hide().eq(index).fadeIn();
    container.find('.series-detail_textarea').find('.series-detail_text').hide().eq(index).fadeIn();
    return false;
  });
});
//Scroll
var scrollFlag = '';
function scrollSearch(scrollPosition) {
	var showPosition = 50;
	if(scrollPosition < showPosition && scrollFlag != 'min') {
    scrollFlag = 'min';
    $('body').removeClass('is-scroll');
  } else if(scrollPosition >= showPosition && scrollFlag != 'over') {
    scrollFlag = 'over';
    $('body').addClass('is-scroll');
  }
}
var stickyScrollFlag = '';
function stickyScroll(scrollPosition) {
  if($(window).width() < $(window).height()) {
    var container = $('.sec01').find('.visual').find('.imagearea');
    var tgt = container.find('img');
    var endNum = tgt.width() - container.width();
    var togglePosTop = container.offset().top;
    var togglePosBottom = togglePosTop + endNum;
    if(scrollPosition < togglePosTop && stickyScrollFlag != 'min') {
      stickyScrollFlag = 'min';
      tgt.css('transform','translate3d(0,0,0)');
    } else if(togglePosTop <= scrollPosition && scrollPosition <= togglePosBottom) {
      if(stickyScrollFlag != 'in') {
        stickyScrollFlag = 'in';
      }
      var tNum = scrollPosition - togglePosTop;
      tgt.css('transform','translate3d(-'+tNum+'px,0,0)');
    } else if(togglePosBottom < scrollPosition && stickyScrollFlag != 'over') {
      stickyScrollFlag = 'over';
      tgt.css('transform','translate3d(-'+endNum+'px,0,0)');
    }
  } else {
    $('.sec01').find('.visual').find('img').css('transform','');
  }
}
var currentSectionFlag = '';
function currentSection(scrollPosition) {
  var image = $('.sec01').find('.series-container').find('.imagearea').find('li');
  if($(window).width() < $(window).height()) {
    var togglePos = $('.series-group.series-group_discover').offset().top - image.closest('.imagearea').outerHeight();
  } else {
    var togglePos = $('.series-group.series-group_discover').offset().top - parseInt(image.closest('.imagearea').css('paddingTop')) - image.height() / 2;
  }
  if(scrollPosition < togglePos && currentSectionFlag != 'all') {
    currentSectionFlag = 'sirius';
    image.removeClass('is-current').eq(0).addClass('is-current');
  } else if(togglePos < scrollPosition && currentSectionFlag != 'discover') {
    currentSectionFlag = 'discover';
    image.removeClass('is-current').eq(1).addClass('is-current');
  }
}
$(window).on('load scroll',function(){
  var scrollPosition = $(window).scrollTop();
  scrollSearch(scrollPosition);
  currentSection(scrollPosition);
  stickyScroll(scrollPosition);
});
//Resize
var winW = $(window).width();
$(window).on('resize',function(){
  if(winW != $(window).width()) {
    setVw();
    toggleHeight();
    var scrollPosition = $(window).scrollTop();
    stickyScroll(scrollPosition);
    currentSection(scrollPosition);
    winW = $(window).width();
  }
});
//LazySizes
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
window.lazySizesConfig.customMedia = {
  '--sp': '(max-width: 767px)',
  '--pc': '(min-width: 768px)',
  '--full': '(min-width: 1367px)',
  '--portrait': '(orientation: portrait)',
};